import React, { Component } from "react";
import { Table, Modal } from "react-bootstrap";

import { appConfig } from "../../config";
var dateFormat = require("dateformat");
class SupportView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const data = this.props.SupportDtls ? this.props.SupportDtls : null;
    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Support Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <div className="feedbkModalTbl">
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td className="feedbkTdWdth">Ticket No.</td>
                        <td className="storeModalCap">
                          {data !== null && data.ticketNo}
                        </td>
                      </tr>

                      <tr>
                        <td className="feedbkTdWdth">Support Type</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.sprtType !== null &&
                            data.sprtType.supportType}
                        </td>
                      </tr>
                      <tr>
                        <td className="feedbkTdWdth">Description</td>
                        <td className="storeModalCap">
                          {data !== null && data.issueDesc}
                        </td>
                      </tr>
                      <tr>
                        <td className="feedbkTdWdth">Status</td>
                        <td className="storeModalCap">
                          {data !== null && data.status}
                        </td>
                      </tr>
                      <tr>
                        <td className="feedbkTdWdth">Date</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            dateFormat(data.createdAt, "mediumDate")}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default SupportView;
